<template>
    <div class="home-page">
        <section>
            <el-carousel ref="carousel" class="page-carousel" arrow="never">
                <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                    <div class="carousel-content" style="width: 100%;height: 100%" @click="handleClickBanner(item)" @mouseenter="onMouseEnter" @mousemove="onMouseMove" @mouseleave="onMouseLeave">
                        <video v-if="item.url.split('.').pop() === 'mp4'" autoplay muted playsinline loop :src="item.url"></video>
                        <el-image v-else :src="item.url" ></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </section>
        <section class="banner top fixed" @mouseenter="onMouseEnter" @mousemove="onMouseMove" @mouseleave="onMouseLeave">
            <div style="width: 100%; height: 100%; cursor: pointer;" @click="handleClickBanner(item)" v-for="(item, index) in topBanners" :key="index">
                <video v-if="item.url.split('.').pop() === 'mp4'" class="video" autoplay muted playsinline loop :src="item.url" style="width: 100%;height: 100%;"></video>
                <el-image v-else :src="item.url" style="width: 100%;"></el-image>
            </div>
        </section>
        <div class="news">
            <div class="news-content">
                <div class="news_label">
                    <span>企业动态</span>
                    <span>了解中协最新动态</span>
                </div>
                <div class="news-view">
                    <div class="activity news-item" v-for="(item, index) in activityList" :key="index" @click="handleClick(item, index)">
                        <div class="news-item__tip">
                            {{tipList[index].tip}}
                        </div>
                        <el-image class="activity-image" :src="item.imagePath"></el-image>
                        <div class="activity-content">
                            <div class="activity-title">
                                {{ item.title }}
                            </div>
                            <div class="activity-info">
                                <span class="info-tip address">{{ item.addr }}</span>
                                <span class="info-tip time">{{ filterTime(item.releaseTime, index) }}</span>
                            </div>
                            <span class="activity-text">
                                {{ item.introduction }}
                            </span>
                        </div>
                    </div>
                    <div class="new news-item" v-if="tipList.length > 0">
                        <div class="icon">{{tipList[2].tip}}</div>
                        <div class="item-view">
                            <el-scrollbar style="height: 100%">
                                <div class="item" v-for="(item, index) in newsList" :key="index" @click="handleClick(item, 2)">
                                    <span>{{ item.introduction }}</span>
                                    <span>{{ filterTime(item.releaseTime) }}</span>
                                </div>
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
            </div>
            <div class="news-buttons">
                <div :class="['button', `news-buttons-${index}`]" v-for="(tip, index) in tipList" :key="index" @click="handleClickBanner(tip, '0')">
                    <span>{{ tip.tip }} ></span>
                </div>
            </div>
        </div>
        <section class="footerBanner" @mouseenter="onMouseEnter" @mousemove="onMouseMove" @mouseleave="onMouseLeave">
            <div style="width: 100%; height: 100%; cursor: pointer;" v-for="(item, index) in bottomBanners" @click="handleClickBanner(item)" :key="index">
                <video v-if="item.url.split('.').pop() === 'mp4'" class="video" autoplay muted playsinline loop :src="item.url" style="width: 100%;height: 100%;"></video>
                <el-image v-else :src="item.url" style="width: 100%;"></el-image>
            </div>
        </section>
        <div class="tip" :style="{left: `${ position.left }px`, top: `${ position.top }px`}">点击查看详情</div>
    </div>
</template>

<script>
import {getContentById, getMenuInfo, tableData} from "@/common/api";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"
import { ElMessage } from "element-plus";
import moment from "moment";
import { useStore } from "vuex";
import router from "@/route";
import { findItemRecursive } from "@/common/urtils";

export default {
    name: "homePage",
    data() {
        return {
            initMenu: false,
            position: {
                top: -200,
                left: -200
            },
            showHome: false,
            store: useStore(),
            bannerList: [],
            topBanners: [],
            bottomBanners: [],
            bannerSrc: require("../assets/footer-bg-1.png"),
            footerBannerSrc: require("../assets/footer-bg-2.png"),
            newsList: [],
            tipList: [
                { parentId: "", tip: "暂无信息", activeIndex: 1},
                { parentId: "", tip: "暂无信息", activeIndex: 1},
                { parentId: "", tip: "暂无信息", activeIndex: 1}
            ],
            activityList: [
                {
                    title: "新闻名称",
                    addr: "位置",
                    releaseTime: new Date(),
                    introduction: "暂无简介"
                },
                {
                    title: "新闻名称",
                    addr: "位置",
                    releaseTime: new Date(),
                    introduction: "暂无简介"
                },
            ],
            lastScrollTop: 0,
            panels: [],
            scrollTween: {},
            observer: {},
            homeParentInfo: {},
            enterImage: false,
        }
    },
    methods: {
        onMouseLeave() {
            this.enterImage = false;
            this.position = {
                top: -200,
                left: -200
            }
        },
        onMouseMove(e) {
            this.position = {
                top: e.clientY + 20,
                left: e.clientX + 10
            }
        },
        handleClickBanner(data, type) {
            if(!data.type || type) {
                ElMessage.warning("未设置跳转菜单或者资源~")
            }
            let pageType = data.type || type
            switch (pageType) {
                case "0":
                    getMenuInfo(data.id).then(res=> {
                        if(res.success) {
                            let level = res.data.level
                            if(level === "1") {
                                var activeIndex = this.store.state.menuList.findIndex(e=>e.id === data.id)
                                router.push({
                                    path: res.data.route,
                                    query: {
                                        level: res.data.level,
                                        menuId: data.id,
                                        parentId: data.id,
                                        activeTag: 0,
                                        activeIndex: activeIndex
                                    }
                                })
                            }else {
                                var array = findItemRecursive(this.store.state.menuList, data.id);
                                var index = this.store.state.menuList.findIndex(e=>e.id === array[0].id)
                                router.push({
                                    path: res.data.route,
                                    query: {
                                        level: res.data.level,
                                        menuId: data.id,
                                        parentId: array[0].id,
                                        activeTag: 0,
                                        activeIndex: index
                                    }
                                })
                            }
                        }else {
                            ElMessage.error(res.msg)
                        }
                    }).catch(()=>{
                        ElMessage.error("跳转指定页面失败")
                    })
                    break;
                case "1":
                    getContentById(data.id).then(res=> {
                        if(res.success) {
                            var array = findItemRecursive(this.store.state.menuList,  res.data.menuId);
                            var parentId = array[0].id;
                            var index = this.store.state.menuList.findIndex(e=>e.id === array[0].id);
                            router.push({
                                path: `/cvi/home/article/view`,
                                query: {
                                    newId: data.id,
                                    parentId: parentId,
                                    activeIndex: index,
                                    activeTag: 0,
                                    type: 0
                                }
                            })
                        }else {
                            console.log('12312312')
                        }
                    }).catch(()=> {
                        ElMessage.error("跳转指定页面失败")
                    })
                    break;
            }
        },
        onMouseEnter(e) {
            this.enterImage = true;
            this.position = {
                top: e.clientY + 20,
                left: e.clientX + 10
            }
        },
        filterTime(time) {
            return moment(time).format("YYYY年MM月DD日")
        },
        handleMenuClick(item) {
            if(item.parentId) {
                // let dix = this.store.state.menuList.findIndex(e=>e.id === item.parentId)
                // console.log('dix', this.store.state.menuList[dix].route)
                // router.push({
                //     path: this.store.state.menuList[dix].route,
                //     query: {
                //         menuId: item.parentId,
                //         parentId: item.parentId,
                //         activeIndex: dix,
                //         activeTag: 0,
                //         type: 1
                //     }
                // })
            }
        },
        handleClick(item, index) {
            if(item.id) {
                let id = this.tipList[index].parentId
                let dix = this.store.state.menuList.findIndex(e=>e.id === id)
                console.log('dix', dix)
                router.push({
                    path: `/cvi/home/article/view`,
                    query: {
                        newId: item.id,
                        parentId: this.tipList[index].parentId,
                        activeIndex: dix,
                        activeTag: 0,
                        type: 1
                    }
                })
            }
        },
        topBannerAnimation() {
            gsap.set(".banner.top",{
                opacity: 0,
                y: 50
            })
            gsap.to('.banner.top',{
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: "power1",
                scrollTrigger: {
                    trigger: ".banner.top",
                    start: "top center+=30%",
                    end: "bottom top-=10%",
                }
            })
            gsap.set(".footerBanner", {
                x: -300,
                opacity: 0,
            })
            gsap.to('.footerBanner',{
                x: 0,
                opacity: 1,
                duration: 0.8,
                ease: "power1",
                scrollTrigger: {
                    trigger: ".footerBanner",
                    start: "top bottom-=5%",
                    end: "bottom top-=10%",
                }
            })
        },
        newsAnimation() {
            gsap.set(".news_label", {
                opacity: 0,
                y: 20
            })
            gsap.to(".news_label", {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "bounce",
                scrollTrigger: {
                    trigger: ".news_label",
                    start: "top center+=30%",
                    end: "bottom top-=10%",
                },
            })

            gsap.utils.toArray(".news-item").forEach((item, index)=> {
                gsap.set(item,{
                    opacity: 0,
                    y: 50
                })
                gsap.set(`.news-buttons-${index}`,{
                    opacity: 0
                })
                gsap.to(item, {
                    opacity: 1,
                    y: 0,
                    ease: "power1",
                    duration: 0.4,
                    delay: 0.6 * (index + 1),
                    onComplete:()=>{
                        gsap.to(`.news-buttons-${index}`, {
                            opacity: 1,
                            ease: "power1",
                            duration: 0.4
                        })
                    },
                    scrollTrigger: {
                        trigger: item,
                        start: "top bottom-=30%",
                        end: "bottom top-=10%",
                    }
                })
            })
        },
        getInitData(data) {
            tableData(data.id).then(res => {
                if(res.success) {
                    // console.log(res.data);
                    this.handleHomeInitData(res.data);
                }else {
                    ElMessage.error(res.msg)
                }
            }).catch(()=>{
                ElMessage.error("获取菜单资源失败，请重试")
            })
        },
        splitInitData(data, type) {
            if(data[0][type] === "" || data[0][type] === null || data[0][type] === undefined) {
                return [];
            }else {
                let array = data[0][type].split(",")
                let newArray = []
                array.forEach(e=> {
                    newArray.push({
                        url: e.split("#")[0],
                        id: e.split("#")[1] === undefined ? "" : e.split("#")[1],
                        type: e.split("#")[2] === undefined ? "" : e.split("#")[2]
                    })
                })
                return newArray
            }
        },
        filterMenuIds(data, type) {
            console.log(data,type)
            if(data[0][type] === "" || data[0][type] === null || data[0][type] === undefined) {
                return [];
            }
            return data[0][type].split(",")
        },
        handleHomeInitData(data) {
            let menuIds = this.filterMenuIds(data, 'menuIds')
            this.bannerList = this.splitInitData(data, 'carousels')
            this.topBanners = this.splitInitData(data, 'topBanners')
            this.bottomBanners = this.splitInitData(data, 'bottomBanners')
            menuIds.forEach((e, index)=>{
                if(e !== "") {
                    let data = findItemRecursive(this.store.state.menuList, e);
                    this.tipList[index].parentId = data[0].id;
                    this.tipList[index].id = e;
                    this.tipList[index].activeIndex = 1;
                    this.tipList[index].tip = data[data.length - 1].name;
                    tableData(e).then(res=>{
                        if(res.success) {
                            if(index === 0 && res.data.length > 0) {
                                this.activityList[0] = res.data[0]
                            }else if(index === 1 && res.data.length > 0) {
                                this.activityList[1] = res.data[0]
                            }else if(index === 2 && res.data.length > 0) {
                                this.newsList = res.data.slice(0, 10)
                            }
                        }
                    })
                }
            })
            this.$nextTick(()=> {
                setTimeout(()=>{
                    window.scrollTo({
                        top: 0
                    })
                    this.topBannerAnimation();
                    this.newsAnimation();
                }, 80)
            })
        },
    },
    beforeUnmount() {
        gsap.killTweensOf(".news")
        gsap.killTweensOf(".news-item")
        gsap.killTweensOf(".banner")
        gsap.killTweensOf(".footerBanner")
        gsap.killTweensOf(".news-buttons-0")
        gsap.killTweensOf(".news-buttons-1")
        gsap.killTweensOf(".news-buttons-2")
    },
    mounted() {
        window.scrollBy(0, 0);

        let interavl = setInterval(()=>{
            if(!this.initMenu && this.store.state.menuList.length > 0) {
                this.initMenu = true;
                window.clearInterval(interavl)
                const data = this.store.state.menuList[0]
                gsap.registerPlugin(ScrollTrigger)
                this.getInitData(data);
            }
        },200)
    }
}
</script>

<style lang="less" scoped>
    .tip {
        position: fixed;
        padding: 10px 15px;
        background-color: #333333;
        color: #FFFFFF;
        border-radius: 5px;
        line-height: 1;
        z-index: 500;
    }
    .el-image {
        display: block;
        cursor: pointer;
    }
    .home-page {
        width: 100%;
        height: 100%;
        .panel {
            height: 100vh;
            top: 0;
            will-change: transform;
        }
        ::v-deep .page-carousel {
            height: 100vh;
            video {
                width: 100%;
                object-fit: cover;
                height: 100% !important;
                cursor: pointer;
            }
            .el-image {
                width: 100%;
                height: 100% !important;
            }
            .el-carousel__container{
                height: 100vh;
            }
            .el-carousel__indicators {
                bottom: 20px;
                .el-carousel__indicator {
                    .el-carousel__button {
                        width: 100px;
                        height: 3px;
                        background-color: rgba(255, 255, 255, 0.3);
                    }
                    &.is-active{
                        .el-carousel__button {
                            background: #FF6900;
                        }
                    }
                }
            }

            .page-carousel__item {
                width: 100%;
                height: 100vh;
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;
            }
        }
    }
    .banner {
        width: 100%;
        height: 100vh;
        will-change: transform;
        video {
            object-fit: cover;
        }
        .el-image {
            width: 100%;
            height: 100%;
        }
        //&.active{
        //    opacity: 1;
        //    transform: translateY(0);
        //}
    }
    .footerBanner {
        width: 100%;
        will-change: transform;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .fixed {
        width: 100%;
        .top-banner {
            width: 100%;
            height: 100%;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            background-image: url("~@/assets/footer-bg-1.png");

        }
        &.footer {
            margin-bottom: 20px;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            background-image: url("~@/assets/footer-bg-2.png");
        }
    }
    .news {
        //margin-top: 20px;
        width: 100%;
        height: 1000px;
        background-image: url("~@/assets/home-bg.png");
        background-position: center center;
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .news_tip {
            will-change: transform;
            font-size: 22px;
            line-height: 20px;
            font-weight: bold;
            color: #FF6900;
            align-self: start;
            transition: opacity .8s, transform .8s;
            transform-origin: left center;
        }
        .news_label {
            align-self: start;
            will-change: transform;
            display: flex;
            flex-direction: column;
            span {
                font-size: 34px;
                color: #184079;
                font-weight: bold;
                &:nth-of-type(1) {
                    font-size: 22px;
                    line-height: 20px;
                    color: #FF6900;
                    margin-bottom: 4px;
                }
            }
        }
        .news-content {

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .news-item {
                height: 560px;
                width: 380px;
                margin-left: 30px;
                background-color: #F2F2F2;
                position: relative;
                transition-timing-function: linear;
                flex-shrink: 0;
                will-change: transform;
                &:hover {
                    ::v-deep .el-image {
                        .el-image__inner {
                            transform: scale(1);
                        }
                    }
                }
                ::v-deep .el-image {
                    border: 1px solid #DFDFDF;
                    .el-image__inner {
                        transition: 0.8s linear;
                        transform: scale(1.1);
                    }
                }
                .news-item__tip {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100px;
                    height: 40px;
                    z-index: 88;
                    background: #666666;
                    text-align: center;
                    line-height: 40px;
                    font-size: 16px;
                    color: #FFFFFF
                }
                &:nth-of-type(1) {
                    margin-left: 0;
                }
                &.activity {
                    cursor: pointer;
                    .activity-image {
                        width: calc(100% - 2px);
                        height: 298px;
                    }
                    .activity-content {
                        height: calc(100% - 380px);
                        padding: 30px 22px 40px;
                        display: flex;
                        flex-direction: column;
                        .activity-title {
                            font-size: 18px;
                            color: #333333;
                            font-weight: bold;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .activity-info {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .info-tip {
                                font-size: 14px;
                                color: #333333;
                                position: relative;
                                display: flex;
                                align-items: center;
                                padding-left: 22px;
                                margin: 15px 0 25px;
                                &.address {
                                    &::after {
                                        background-image: url("~@/assets/home-address-icon.png");
                                    }
                                }
                                &.time {
                                    &::after {
                                        background-image: url("~@/assets/home-time-icon.png");
                                    }
                                }
                                &::after {
                                    content: "";
                                    position: absolute;
                                    left: 0;
                                    width: 17px;
                                    height: 17px;
                                    background-size: cover;
                                    background-position: center center;
                                }
                            }
                        }
                        .activity-text {
                            letter-spacing: 1px;
                            font-size: 16px;
                            color: #666666;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
                &.new {
                    display: flex;
                    flex-direction: column;
                    overflow-y: auto;
                    .icon {
                        width: 100px;
                        height: 40px;
                        flex-shrink: 0;
                        background: #666666;
                        text-align: center;
                        line-height: 40px;
                        font-size: 16px;
                        color: #FFFFFF
                    }
                    .item-view {
                        height: calc(100% - 50px);
                        overflow-y: hidden;
                        .item {
                            cursor: pointer;
                            padding: 0 20px;
                            height: 120px;
                            margin-bottom: 5px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            &:hover {
                                span {
                                    color: #ff6600 !important;
                                }
                            }
                            span {
                                font-size: 18px;
                                color: #333333;
                                &:nth-of-type(1) {
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                }
                                &:nth-of-type(2) {
                                    margin-top: 10px;
                                    font-size: 16px;
                                    color: #666666;
                                }
                            }
                        }
                    }

                }
                &::after {
                    width: 100px;
                    height: 40px;
                    background: #666666;
                    position: absolute;
                    top: 0;
                    left: 0;
                    text-align: center;
                    line-height: 40px;
                    font-size: 16px;
                    color: #FFFFFF
                }
            }
            .news-view {
                margin: 50px 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .news-buttons {
            width: 1200px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            .button {
                flex: 1;
                margin-left: 30px;
                display: flex;
                justify-content: center;
                &:nth-of-type(1) {
                    margin-left: 0;
                }
                span {
                    cursor: pointer;
                    width: 198px;
                    height: 48px;
                    border: 1px solid #333333;
                    font-size: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: transparent;
                    color: #333333;
                    &:hover, &:active {
                        background: #FF6900;
                        border-color: #FF6900;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>
